/**
 * Mapeo entre el primer segmento de la URL (pathname) y la clave de permiso en PERMISSIONS.
 * Usado por RouteGuard para bloquear acceso directo por URL cuando el rol no tiene permiso.
 * Debe estar alineado con MyMenu (to + permission) y con los nombres de Resource en resources.js.
 */
import { getPermissions } from './permissions';

/** Path segment (URL) -> permission key. Casos donde el segmento no coincide con la clave. */
const PATH_TO_PERMISSION = {
  'tour-management': 'tour_management',
  'tour_due_list': 'tour_due_list',
  'rentals_due': 'rentals_due',
  'moto_schedule': 'moto_schedule',
  'gps_schedule': 'gps_schedule',
  'vans_schedule': 'vans_schedule',
  'weekly_rentals': 'weekly_rentals',
  'current_fleet': 'current_fleet',
  'fleet_allocation': 'fleet_allocation',
  'tour_prices': 'tour_prices',
  'tour_list': 'tour_list',
  'clientsMerge': 'clientsMerge',
  'unentered_km_rentals': 'unentered_km_rentals',
  'extra_km_rentals': 'extra_km_rentals',
  'vehicle_damages': 'vehicle_damages',
  'black_lists': 'black_lists',
  'gps_devices': 'gps_devices',
  'maintenances_due': 'maintenances_due',
  'tour_names': 'tour_names',
};

/**
 * Obtiene la clave de permiso para una ruta, si existe en PERMISSIONS.
 * @param {string} pathname - ej. "/clients", "/clients/123", "/tour-management"
 * @returns {string|null} - clave de permiso o null si la ruta no está controlada por RBAC
 */
export const getPermissionKeyForPath = (pathname) => {
  if (!pathname || pathname === '/') return 'dashboard';
  const segment = pathname.split('/').filter(Boolean)[0];
  if (!segment) return 'dashboard';
  const perms = getPermissions();
  if (perms == null || typeof perms !== 'object') return null;
  const permissionKey = PATH_TO_PERMISSION[segment] != null ? PATH_TO_PERMISSION[segment] : segment;
  return permissionKey in perms ? permissionKey : null;
};



// WEBPACK FOOTER //
// ./src/rbac/routePermissionMap.js